/**
 * CURRENCY_SERVICE_INITIALIZED will be dispatched when the currency service is initialized successfully.
 */
export const CURRENCY_SERVICE_INITIALIZED = 'CURRENCY_SERVICE_INITIALIZED';

/**
 * CURRENCY_LOADED_EVENT will be dispatched when the currency data is loaded from local storage or
 * fetched from the server if it wasn't found in local storage.
 */
export const CURRENCY_LOADED_EVENT = 'CURRENCY_LOADED_EVENT';

/**
 * CURRENCY_CHANGED_EVENT will be dispatched when the currency is changed by the user.
 */
export const CURRENCY_CHANGED_EVENT = 'CURRENCY_CHANGED_EVENT';

/**
 * DIRECT_CHECKOUT_WIDGET_CONFIG_CHANGED_EVENT should be dispatched when we need to reload direct
 * checkout widget configuration. See window.directCheckoutWidgetConfig in the header.php for more
 * information.
 */
export const DIRECT_CHECKOUT_WIDGET_CONFIG_CHANGED_EVENT = 'directCheckoutWidgetConfigChanged';
